import { createStore } from 'vuex'
const crmPost = (action, payload) => axios.post(window.CRMProxy + '/v1/' + action, payload)

export default createStore({
    state: {
        pageSetup: null,
        formSetup: null,
        indexPromo: null,
        premsArr: null,

        locationArr: null,
        conceptArr: null,
        innerContentArr: null,
        lobbiArr: null,
        apartmentsArr: null,
        galleryArr: null,
        newsArr: null,
        newsData: null,

        isOpenFormModal: false,
        isOpenModalPromo: false,
        isOpenSendwich: false,
        isOpenFormLandModal: false,
        // flats CRM VARS
        salesCardPage: null,
        salesCardContent: null,
        saleFilterParams: null,
        flatsItems: null,
        flatCard: null,
        flatsFilterData: null,
        flatsPagination: {
            allApartments: 0,
            remainingApartments: 0,
            remainingPages: 0,
        },
        pagin_PageNumber: 1,
        gridView: true,
        flatsEmptyMsg: false,
        objectDataCrm: null,
        visibleFilterMobile: false,
        FilterResetTrigger: false,
        modalData: null,
        isMobileGlobal: null,
        // gCap_siteKey: '6LfTd80pAAAAAGDLmvv79QDyblIisbXodb_VMUot',
        gCap_siteKey: '6LdVVW4qAAAAAMha4R9iKo9YBlu5Lw7WDrgmSg9x',
    },
    getters: {
        loadIsOpenFormLandModal: state => state.isOpenFormLandModal,
        loadOpenFormModal: state => state.isOpenFormModal,
        loadOpenModalPromo: state => state.isOpenModalPromo,
        loadOpenSendwich: state => state.isOpenSendwich,
        //Get global lang Content Var
        loadPageSetUp: state => state.pageSetup,
        loadFormSetUp: state => state.formSetup,
        loadIndexPromo: state => state.indexPromo,
        loadPremsArr: state => state.premsArr,

        loadLocation: state => state.locationArr,
        loadConcept: state => state.conceptArr,
        loadInnerContent: state => state.innerContentArr,
        loadLobbiArr: state => state.lobbiArr,
        loadApartments: state => state.apartmentsArr,
        loadGalleryArr: state => state.galleryArr,
        loadNews: state => state.newsArr,
        loadNewsData: state => state.newsData,
        //getters for flats CRM
        loadSalesCardPage: state => state.salesCardPage,
        loadSalesCardContent: state => state.salesCardContent,
        loadSalesFilterCardParams: state => state.saleFilterParams,
        loadFlatsItems: state => state.flatsItems,
        loadFlatCard: state => state.flatCard,
        loadFlatsFilterData: state => state.flatsFilterData,
        loadFlatsPagination: state => state.flatsPagination, // параметры остаточных значений(счетчиков) пагинации
        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg,
        loadObjectDataCrm: state => state.objectDataCrm,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadLandFlatsGridView: state => state.gridView,
        loadSalesLandModalDataArr: state => state.modalData,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadisMobileGlobal: state => state.isMobileGlobal,
        loadGcap_sitekey: state => state.gCap_siteKey,
        loadUcoCRM_auth_token: state => state.ucoCRM_oauth_token,
    },
    actions: {
        installMainLang_Global({commit}, payload) {
            commit('setUp_mainLang', payload);
        },
        clearNewsData({commit}) {
            commit('newsDataClear');
        },
        //// GLOBAL ACTIONS
        getSectionsData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'section?per_page=20').then(async (response) => {
                // console.log(response.data[1].acf)
                if (this.state.pageSetup == null) {
                    return new Promise((resolve, reject) => {
                        commit('PageSetUp', response.data[0].acf);
                        commit('Forms', response.data[1].acf);
                        commit('IndexPromo', response.data[2].acf);
                        commit('Prems', response.data[3].acf);
                        commit('Location', response.data[4].acf);
                        commit('Concept', response.data[5].acf);
                        commit('InnerContent', response.data[6].acf);
                        commit('Lobbi', response.data[7].acf);
                        commit('Apartments', response.data[8].acf);
                        commit('Gallery', response.data[9].acf);
                        commit('News', response.data[10].acf);
                        resolve('complete Get SetUp');
                    });
                }
            });
        },
        // SALES CARD PROMO/LAND
        getSalesCardPageData({commit}) {
            axios.get(window.SalesURL + window.GlobalLang + window.JsonUrl + 'pages/1661').then(async (response) => {
                // console.log(response.data.acf, 'sale CARD PAGE DATA DEFAULT');
                commit('salesCardPage', response.data.acf);
            });
        },
        // oauth 2.0 rest api crm test
        getFlatsItems({commit}, payload) { // FLATS DEFAULT LOAD
            if (this.state.flatsItems == null) {
                return new Promise((resolve) => {
                    crmPost('apartments', payload).then((response) => {
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                    }).catch((error) => {
                        console.log('error getApartments default', error.response ? error.response.status : error.message);
                        resolve('error FLATS');
                    });
                });
            }
        },
        getFlatsByFilter({commit}, payload) { // FLATS LOAD BY FILTER
            crmPost('apartments', payload).then((response) => {
                commit('flatsItemsArr', response.data.data);
            }).catch((error) => {
                console.log('error getApartments filter', error.response ? error.response.status : error.message);
            });
        },
        getFlatsByPagination({commit}, payload) { // pagination
            crmPost('apartments', payload).then((response) => {
                commit('flatsItemsArrPagination', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination', error.response ? error.response.status : error.message);
            });
        },
        getFlatsPagintationCounters({commit}, payload) {
            crmPost('count', payload).then((response) => {
                commit('flatsPaginationCountersSet', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination Counter', error.response ? error.response.status : error.message);
            });
        },
        sendFormDataToCRM({commit}, payload) {
            return new Promise((resolve) => {
                crmPost('lead', payload).then((response) => {
                    resolve(response)
                }).catch((error) => {
                    console.log('error SEND FORM', error.response ? error.response.status : error.message);
                    resolve(error)
                });
            });
        }
    },
    mutations: {
        Open_form_modal(state, data) {
            state.isOpenFormModal = data
        },
        Open_promo_modal(state, data) {
            state.isOpenModalPromo = data
        },
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        //
        PageSetUp(state, data) {
            state.pageSetup = data
        },
        Forms(state, data) {
            state.formSetup = data
        },
        IndexPromo(state, data) {
            state.indexPromo = data
        },
        Prems(state, data) {
            state.premsArr = data
        },

        Location(state, data) {
            state.locationArr = data
        },
        Concept(state, data) {
            state.conceptArr = data
        },
        InnerContent(state, data) {
            state.innerContentArr = data
        },
        Lobbi(state, data) {
            state.lobbiArr = data
        },
        Apartments(state, data) {
            state.apartmentsArr = data
        },
        Gallery(state, data) {
            state.galleryArr = data
        },
        News(state, data) {
            state.newsArr = data
        },
        //////////// CRM BAZIS FLATS MUTATIONS
        salesCardPage(state, data) {
            state.salesCardPage = data;
        },
        salesCardContent(state, data) {
            state.salesCardContent = data;
        },
        FilterSaleItemCard_Set(state, data) {
            state.saleFilterParams = data
        },

        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
            } else {
                state.flatsEmptyMsg = false
            }
        },
        flatsItemsArrPagination(state, data) {
            // console.log(data, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            // console.log(state.flatsItems);
        },
        flatsPaginationCountersSet(state, data) {
            state.flatsPagination.allApartments = data.allApartments;
            state.flatsPagination.remainingApartments = data.remainingApartments;
            state.flatsPagination.remainingPages = data.remainingPages;
        },
        setObjectDataCRM(state, data) {
            state.objectDataCrm = data[0];
        },
        setFlatsFilterData(state, data) {
            state.flatsFilterData = data
        },
        UpdatePaginPageNumber(state, data) {
            state.pagin_PageNumber = data
        },
        // mutations for news section
        newsData(state, data) {
            state.newsData.push(data);
            console.log(state.newsData, 'asdasdsad')
        },
        newsDataClear(state, data) {
            state.newsData = []
        },
        // for flats
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        gridView(state, data) {
            state.gridView = data;
        },
        modalData(state, data) {
            state.modalData = data
        },
        isMobileGlobalSet( state, data) {
            state.isMobileGlobal = data
        },
        Open_FormLandModal(state, data) {
            state.isOpenFormLandModal = data
        },
    },
})
